/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Product/all',[
    'global/all',
    './Product',
    './ItemTools',
    './PrevNext',
    './ProductAddToCart',
    './ProductAddToCart.Forms',
    './ProductAccordion',
    './ProductImage',
    './ProductPrice',
    './Selections',
    './ProductSpecifications'
], function (Roc, Product, ItemTools, PrevNext, ProductAddToCart, ProductAddToCartForms, ProductAccordion, ProductImage, ProductPrice, Selections, ProductSpecifications) {
    Roc.Logger.debug('All Product Dependencies Loaded');

    Product.ItemTools = ItemTools;
    Product.PrevNext = PrevNext;
    Product.ProductAddToCart = ProductAddToCart;
    Product.ProductAddToCartForms = ProductAddToCartForms;
    Product.ProductAccordion = ProductAccordion;
    Product.ProductImage = ProductImage;
    Product.ProductPrice = ProductPrice;
    Product.Selections = Selections;
    Product.ProductSpecifications = ProductSpecifications;

    return Product;
});

